import { Title } from '@angular/platform-browser';
import { GlobalConstants } from './../../../common/global-constants';
import { ForecastOverviewTableData, SelectStatementCaption } from './../../../models/forecast/fc-overview-models';
import { ExportFilter, FilterInput, FilterMappingService} from './../../../models/filter-objects';
import { DxChartComponent, DxDataGridComponent, DxRangeSelectorComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { UtilsService } from './../../../services/utils.service';
import { DevTooltipCustComponent } from './../../../widgets/dev-tooltip-cust/dev-tooltip-cust.component';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { ForecastService } from '../../forecast/forecast.service';
import { HelpService } from '../../help/help.service';
import { ActivatedRoute, Data } from '@angular/router';
import { ShareDataService } from 'src/app/services/share-data.service';
import { TaskService } from '../../task/task.service';

import { FileExportService } from 'src/app/common/file-export-service';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { firstValueFrom } from 'rxjs';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { FiltersGroupBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/filters-group-bookmark-elements.operator';
import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';
import { QueryFilterParameter } from 'src/app/widgets/filters/models/query-filter-parameter.model';

@Component({
    selector: 'app-statistical-forecasting-overview',
    templateUrl: './statistical-forecasting-overview.component.html',
    styleUrls: ['./statistical-forecasting-overview.component.scss'],
    standalone: false
})
export class StatisticalForecastingOverviewComponent implements OnInit {

	//chart value range
	visualRange: any;

	//default data initialization
	forecastDevelopmentChartSource: any = [];
	yearOnYearChartDataSource: any = [];
	seasonalityChartDataSource: any = [];

	CustSelectionOption: any = [];
	OverviewQuantity: any = [];
	datata: any = { value: 'selectedRawItem' };
	forecastTagboxData: any = [];


	//default parameters
	action = 'Filter';
	Action = 'Data';
	Unit = 'Quantity';
	settingGroupId = 37;

	UnitOfMeasure = 'BaseUnit';

	currentlySelectedFilters: FilterInput[] = [];
	lastSelectedFilter: FilterInput;

	// Overview Table
	tableColumnsDataSource: SelectStatementCaption[] = [];
	tableValuesDataSource: any[] = [];
	selectedFcTableRecords: ForecastOverviewTableData[] = [];
	changedFcTableRecords: ForecastOverviewTableData[] = [];
	issueResponsesDataSource: string[] = [];
	showInfoPopup = false;
	infoPopupMessage = '';
	unsavedChanges = false;
	fitTableToPage = false;
	anyActiveFilters = false;
	infPopupTitle = '';
	period = "period";

	//Filters
	filters: QueryFilterParameter[] = [];
	public pageFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions(
		  {
			filters: async () => this.pageFiltersOperator.appliedFilters,
	
			baseSelectStatementId: BaseSelectStatementId.Dev_GetForecastOverviewFiltersStatistical,
			selectionSetId: SelectionSetId.StatisticalForecastOverviewFilter,
		  }
		)
	);
	//Bookmark
	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;
	  
	private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);
	public bookmarkElementsOperators: BookmarkElementsOperator[];
	
	public async initializeBookmarks(): Promise<Data> {
	let routeData: Data = await firstValueFrom(this._activatedRoute.data);
	
	this.bookmarkElementsOperators = [
		new FiltersGroupBookmarkElementsOperator(
		  {
			id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
			filtersOperator: () => this.pageFiltersOperator
		  }
		)
	];
	
	return routeData;
	}
	
	//dev express setting changes function for chart need on resize after windows size changes
	@ViewChild("forecastDevelopmentChart", { static: false }) dxForecastDevelopmentChart: DxChartComponent;
	@ViewChild("seasonalityChart", { static: false }) dxSeasonalityChart: DxChartComponent;
	@ViewChild("yearOnYearChart", { static: false }) dxYearOnYearChart: DxChartComponent;
	@ViewChild("forecastDevelopmentRangSelct", { static: false }) forecastDevelopmentRangSelct: DxRangeSelectorComponent;
	@ViewChild("SelectBoxOverviewQuantitySelct", { static: false }) SelectBoxOverviewQuantitySelct: DxSelectBoxComponent;
	@ViewChild('editingDataGrid', { static: false }) dataGrid: DxDataGridComponent;

	constructor(
		private forecastService: ForecastService, private helpService: HelpService,
		private titleService: Title, private shareDataService: ShareDataService,
		private route: ActivatedRoute, private taskService: TaskService, private fileExportService: FileExportService,
		private tableParamService: TableParameterService
	) { }

	ngAfterViewInit(): void {
	}

	async ngOnInit() {
		this.titleService.setTitle("Statistical Forecasting Overview");
		this.initFilterOptions();
		this.GetSettingsData();
		this.WebSettingsPivot();
		await this.initializeBookmarks();
    	this.loadPageData();
    	this.pageFiltersOperator.onFiltersApplied.subscribe(
      	 (selection) => {
         	this.shareDataService.CleanData();
         	this.shareDataService.filterOptionOverview = selection.output;
         	this.pageFiltersOperator.load(
         	  {
         	    showLoadingIndicator: true,
         	  }
         	);
			this.loadLengendToShare();
			this.getData();
         	this.ExportToExcelFilters = this.filterMappingService.mapQueryFilterOutputToFilterValue(this.shareDataService.filterOptionOverview.filters);
      	 }
    	);
	}

	public async loadPageData() {
		(await this.pageFiltersOperator.getObservable(
			{
				showLoadingIndicator: true,
			}
		)).subscribe(
			{
				next: async (_) => {
					if (!(await this.bookmarksGroup.applyDefaultBookmark())) {
						this.loadLengendToShare();
			 			this.getData();
					}
				}
			}
		);
	}

	private initFilterOptions() {
		this.forecastService.GetSelectionOption("UOMT-OWIG", "").subscribe(data => {

			if (data) {
				this.CustSelectionOption = data.custSelection;
				this.OverviewQuantity = data.lists;
				this.LoadTagBoxData();
			}
			else {
				//setting data to null if no data found
				this.forecastDevelopmentChartSource = [];
				this.yearOnYearChartDataSource = [];
				this.seasonalityChartDataSource = [];
			}
		}, err => {
			console.log(err)
		});

	}

	private LoadTagBoxData() {
		this.forecastService.GetTagSelectionOption("get-overviewfilter", "").subscribe(data => {

			this.forecastTagboxData = data[0];
	

		}, err => {
			console.log(err)
		});

	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	//load data on each event
	private getData() {
		this.Unit = (this.SelectBoxOverviewQuantitySelct.value);
		this.dxForecastDevelopmentChart.instance.showLoadingIndicator();
		this.dxSeasonalityChart.instance.showLoadingIndicator();
		this.dxYearOnYearChart.instance.showLoadingIndicator();

		this.forecastService
			.getOverviewDataStatistical(this.Action, this.Unit, this.settingGroupId, this.UnitOfMeasure, this.pageFiltersOperator.overviewFiltersOutput.filters).toPromise().then(data => {

				if (data) {
					this.forecastDevelopmentChartSource = data.forecastDevelopmentChart;

					// Intialize visual range with min and max values to prevent ExpressionChangedAfterItHasBeenCheckedError.
					this.visualRange = [
						this.forecastDevelopmentChartSource[0].period,
						this.forecastDevelopmentChartSource[this.forecastDevelopmentChartSource.length - 1].period
					];

					this.dxForecastDevelopmentChart.instance.hideLoadingIndicator();
					const compare = (a, b) => {
						return +a.month > +b.month ? 1 : -1;
					}
					this.seasonalityChartDataSource = data.forecastSeasonalityChartPers;
					this.seasonalityChartDataSource.sort(compare);
					this.dxSeasonalityChart.instance.hideLoadingIndicator();

					this.yearOnYearChartDataSource = data.forecastYearOnYearChart;
					this.dxYearOnYearChart.instance.hideLoadingIndicator();

					//adding for year on year chart data need to be serials
					if (data.forecastYearOnYearChart != null) {
						data.forecastYearOnYearChart.forEach(EachItem => {
							if (EachItem != null) {
								this.yearOnYearChartDataSource.push({ DataName: 'RXY', DataValue: EachItem.rxy });
								this.yearOnYearChartDataSource.push({ DataName: 'FinalForecast3', DataValue: EachItem.finalForecast3 });
								this.yearOnYearChartDataSource.push({ DataName: 'ReleasedForecast', DataValue: EachItem.releasedForecast });
								this.yearOnYearChartDataSource.push({ DataName: 'Actual', DataValue: EachItem.actual });
							}
						});

						this.dxYearOnYearChart.instance.hideLoadingIndicator();
					}
				}
				else {
					//setting data to null if no data found
					this.forecastDevelopmentChartSource = [];
					this.yearOnYearChartDataSource = [];
					this.seasonalityChartDataSource = [];
					this.dxForecastDevelopmentChart.instance.hideLoadingIndicator();
					this.dxSeasonalityChart.instance.hideLoadingIndicator();
					this.dxYearOnYearChart.instance.hideLoadingIndicator();
				}
				this.onResize();
			}).catch((err) => {
				console.log(err, "test error");
			});

		this.getOverviewTableData();
	}

	getOverviewTableData() {
		this.dataGrid.instance.beginCustomLoading('Loading...');
		const $this = this;

		this.forecastService.getForecastingOverviewTableStatistical(this.Action, this.Unit, this.settingGroupId, this.UnitOfMeasure, this.pageFiltersOperator.overviewFiltersOutput.filters).subscribe(result => {
			$this.tableColumnsDataSource = result.columns;
			$this.tableValuesDataSource = result.data;
			$this.dataGrid.instance.endCustomLoading();
			setTimeout(() => {
				$this.LoadChartSeries();
			}, 1000);
		});

		this.forecastService.getIssueResponseDatasource().subscribe(result => {
			this.issueResponsesDataSource = result.map(x => x.listElement);
		});
	}

	//window resize function  refresh all charts
	onResize() {
		setTimeout(() => {
			this.LoadChartSeries();
			this.dxForecastDevelopmentChart.instance.refresh();
			this.dxSeasonalityChart.instance.refresh();
			this.dxYearOnYearChart.instance.refresh();
			this.forecastDevelopmentRangSelct.instance.render();
		});
	}

	//#region Chart Settings and funcation

	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "Year-Month", "", "");
	}

	//adding percentage symbol in seasonality
	customizeText = (info: any) => {
		return Math.round(info.value).toLocaleString() + '%';
	}

	//adding customize Point color for seasonality chart only
	customizePoint = (arg: any) => {
		if (arg.argument != null) {
			if (arg.argument == 'FC') {
				return {
					visible: true,
					color: "#BE4B48"
				};
			}
		}

		return undefined;
	}

	//hide and show series on click
	onLegendClickMainChart(e: any) {
		const series = e.target;
		let ShowHide = false;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
			
		}
		this.loadLengendToShare();
	}

	//hide and show series on click
	onLegendClick(e: any) {
		const series = e.target;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
		}
		this.loadLengendToShare();
	}
	//#endregion

	getMarkerPath(item) {
		return UtilsService.getlegendMarkerPath(item, 'deepdive', GlobalConstants.SvgLinSettingsCollection.statisticalForecastingSettings);
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		const filter = evt.component.getCombinedFilter();
		if (filter) {
			this.anyActiveFilters = true;
		} else {
			this.anyActiveFilters = false;
		}

		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-stat-overview', JSON.stringify(this.dataGrid.instance.state()));
	}

	gridRowUpdated(e) {
		this.unsavedChanges = true;
		this.changedFcTableRecords.push(e.data);
	}

	gridSelectionChanged(data: any) {
		this.selectedFcTableRecords = [];

		data.selectedRowKeys.forEach(element => {
			if (!this.selectedFcTableRecords.includes(element)) {
				this.selectedFcTableRecords.push(element);
			}
		});
	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;

		toolbarItems.unshift({
			location: 'before',
			template: 'expandButtonTemplate'
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		}, {
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		}, {
			location: 'before',
			template: 'saveButtonTemplate'
		}, {
			location: 'before',
			template: 'undoButtonTemplate'
		});
	}

	canEdit(item: any): boolean {
		const dataField = item.column.dataField;
		const correspondingColumn = this.tableColumnsDataSource.find(x => x.columnName === dataField);

		if (correspondingColumn && (correspondingColumn.columnName === 'PermanentComment' || correspondingColumn.columnName === 'IssueResponse')) {
			return true;
		}

		return false;
	}

	changeActiveFiltersStatus() {
		if (this.anyActiveFilters) {
			this.anyActiveFilters = !this.anyActiveFilters;
			this.dataGrid.instance.clearFilter();
			this.ScopeList = [];
			this.ChartSettings.ScopeList = [];
		}
	}

	changeFitToPageStatus() {
		this.fitTableToPage = !this.fitTableToPage;

		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	rowButtonClicked(e, data) {
		e.event.stopPropagation();


		window.open('statistical-forecasting/deep-dive?id=' + UtilsService.getURLHelper(data.data.ForecastObjectClientId), '_blank');

	}

	saveAllChanges() {
		if (this.unsavedChanges) {

			this.forecastService.updateOverviewTableData(this.changedFcTableRecords).subscribe(() => {
				this.showInfoPopup = true;
				this.infoPopupMessage = 'Changes Saved Successfully!';
				this.infPopupTitle = 'Saved';

				this.unsavedChanges = false;
				this.changedFcTableRecords = [];

				setTimeout(() => {
					this.changeInfoPopupStatus();
				}, 3000);
			});
		} else {
			this.showInfoPopup = true;
			this.infoPopupMessage = 'No changes have been done yet.';
			this.infPopupTitle = 'Warning';

			setTimeout(() => {
				this.changeInfoPopupStatus();
			}, 3000);
		}
	}

	undoAllChanges() {
		if (this.unsavedChanges) {

			this.getOverviewTableData();
			this.unsavedChanges = false;

		} else {
			this.showInfoPopup = true;
			this.infoPopupMessage = 'No changes have been done yet.';
			this.infPopupTitle = 'Warning';

			setTimeout(() => {
				this.changeInfoPopupStatus();
			}, 3000);
		}
	}

	deleteSelectedRecords() {

		this.forecastService.deleteOverviewTableData(this.selectedFcTableRecords).subscribe(() => {
			this.getOverviewTableData();
			this.showInfoPopup = true;
			this.infoPopupMessage = 'Tasks deleted successfully!';
			this.infPopupTitle = 'Deleted';

			this.selectedFcTableRecords = [];

			setTimeout(() => {
				this.changeInfoPopupStatus();
			}, 3000);
		});
	}

	changeInfoPopupStatus() {
		this.showInfoPopup = false;
		this.infoPopupMessage = '';
		this.infPopupTitle = '';
	}

	ScopeList = [];
	saveState = (statenew) => {
		this.ScopeList = [];
		if (statenew != null && statenew.columns != null && statenew.columns.length > 0) {
			statenew.columns.forEach(element => {
				if (element.filterValues) {
					this.ScopeList.push({
						fieldName: element.dataField, filterType: element.filterType,
						value: element.filterValues
					});
				}
			});
		}
		this.loadLengendToShare();
	}

	ChartSettings: any;

	IsExportEnable = false;
	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportForecastOverview").subscribe(resultFilename => {
			this.IsExportEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err);
		});
		this.fileExportService.WebSettings("EnableExportStatisticalForecastOverviewList").subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err);
		});
	}

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot("actionpivotStatisticalFCOverview").subscribe(result => {
			console.log(result);
			if (result != null && result.length > 0 && result[0].defaultSelectionTooltipStatisticalFCOverview != null
				&& result[0].defaultSelectionTooltipStatisticalFCOverview.toLowerCase() == "yes") {
				this.EnableTooltip = true;
			}
			if (result != null && result.length > 0 && result[0].enableDisableTooltipStatisticalFCOverview != null
				&& result[0].enableDisableTooltipStatisticalFCOverview.toLowerCase() == "yes") {
				this.ShowTooltip = true;
			}

		}, err => {
			console.log(err);
		});
	}

	loadLengendToShare() {
	
		let seriesValues = { ForecastDevelopmentChart: [], YearOnYearChart: [], SeasonalityChart: [], ScopeList: [] };
		if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.instance != null
			&& this.dxForecastDevelopmentChart.instance.getAllSeries() != null) {
			this.dxForecastDevelopmentChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.ForecastDevelopmentChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.instance != null
			&& this.dxYearOnYearChart.instance.getAllSeries() != null) {
			this.dxYearOnYearChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.YearOnYearChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.instance != null
			&& this.dxSeasonalityChart.instance.getAllSeries() != null) {
			this.dxSeasonalityChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.SeasonalityChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}
		seriesValues.ScopeList = this.ScopeList;
		this.shareDataService.ChartSettings = JSON.stringify(seriesValues);
	}

	LoadChartSeries() {

		if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.series != null && Array.isArray(this.dxForecastDevelopmentChart.series)) {
			for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {
				this.dxForecastDevelopmentChart.series[index].visible = true;
			}
		}
		if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.series != null  && Array.isArray(this.dxSeasonalityChart.series)) {
			for (let index = 0; index < this.dxSeasonalityChart.series.length; index++) {
				this.dxSeasonalityChart.series[index].visible = true;
			}
		}
		if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.series != null  && Array.isArray(this.dxYearOnYearChart.series)) {
			for (let index = 0; index < this.dxYearOnYearChart.series.length; index++) {
				this.dxYearOnYearChart.series[index].visible = true;
			}
		}


		if (this.ChartSettings != null) {
			if (this.ChartSettings.ForecastDevelopmentChart != null && this.ChartSettings.ForecastDevelopmentChart.length > 0) {
				if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.series != null
					&& Array.isArray(this.dxForecastDevelopmentChart.series) && this.dxForecastDevelopmentChart.series.length > 0) {
					for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {
						this.ChartSettings.ForecastDevelopmentChart.forEach(itemchrt => {
							if (this.dxForecastDevelopmentChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxForecastDevelopmentChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxForecastDevelopmentChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}
			if (this.ChartSettings.YearOnYearChart != null && this.ChartSettings.YearOnYearChart.length > 0) {
				if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.series != null
					&& Array.isArray(this.dxYearOnYearChart.series) && this.dxYearOnYearChart.series.length > 0) {
					for (let index = 0; index < this.dxYearOnYearChart.series.length; index++) {
						this.ChartSettings.YearOnYearChart.forEach(itemchrt => {
							if (this.dxYearOnYearChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxYearOnYearChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxYearOnYearChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxYearOnYearChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}
			if (this.ChartSettings.SeasonalityChart != null && this.ChartSettings.SeasonalityChart.length > 0) {
				if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.series != null
					&& Array.isArray(this.dxSeasonalityChart.series) && this.dxSeasonalityChart.series.length > 0) {
					for (let index = 0; index < this.dxSeasonalityChart.series.length; index++) {
						this.ChartSettings.SeasonalityChart.forEach(itemchrt => {
							if (this.dxSeasonalityChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxSeasonalityChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxSeasonalityChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxSeasonalityChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.ScopeList != null && this.ChartSettings.ScopeList.length > 0) {
				if (this.dataGrid != null && this.dataGrid.instance != null) {
					this.dataGrid.instance.clearFilter();
					this.ChartSettings.ScopeList.forEach(element => {
						this.dataGrid.instance.beginUpdate();
						this.dataGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
						if (element.filterType != null && element.filterType != undefined) {
							this.dataGrid.instance.columnOption(element.fieldName, 'filterType', element.filterType);
						}
						this.dataGrid.instance.columnOption(element.fieldName, 'filterValues', element.value);
						this.dataGrid.instance.endUpdate();
					});
				}
			}
		}
	}

	filterMappingService = new FilterMappingService();
	ExportToExcelFilters: ExportFilter[] = [];
	// Method to receive value from child
	receiveExportToExcelFilters(value: ExportFilter[]) {
		this.ExportToExcelFilters = value;
	}
}
